import config from "../../assets/js/conf/config";
import request from "../../assets/js/utils/request";
/**
 * 我的钱包
 */
export function moneyData(data){//获取钱包金额信息
	return request.post(config.baseApi+"/business/basinessmoneyinfo",data)
}
export function checkRecharge(data){//查询旧版充值订单
	// return request.post(config.baseApi+"/business/basinessrecharge",data)
	return request.post(config.baseApi+"/merchant/user/recharge",data)
}
export function createWalletRechargeOrder(data){//创建支付宝网站支付钱包充值订单
	return request.post(config.baseApi+"/merchant/wallet/recharge/orders",data)
}
export function walletRechargeOrder(data){//查询钱包充值订单状态
	return request.get(config.baseApi+"/merchant/wallet/recharge/orders/"+encodeURIComponent(data.out_trade_no),{})
}

export function tixianInfo(data){//获取提现信息
	return request.post(config.baseApi+"/business/basinesstixianinfo",data)
}
export function tixianData(data){//发起提现
	return request.post(config.baseApi+"/business/basinesstixian",data)
}
export function walletData(data){//钱包记录流水
	// return request.post(config.baseApi+"/business/basinessjineflow",data)
	return request.get(config.baseApi+"/merchant/user/userFinanceList",data)
}
export function powerFinanceList(data){//算力流水
	return request.get(config.baseApi+"/merchant/user/powerFinanceList",data)
}
export function conventionalPowerFinanceList(data){//常规算力流水
	return request.get(config.baseApi+"/merchant/userconventionalcomputingpower/finance/list",data)
}
export function powerRecharge(data){//算力充值
	return request.post(config.baseApi+"/merchant/user/powerRecharge",data)
}
export function computingPowerFinanceList(data){//铺货算力流水
	return request.get(config.baseApi+"/merchant/usercomputingpower/finance/list",data)
}
export function computingPowerRecharge(data){//铺货算力充值
	return request.post(config.baseApi+"/merchant/user/computingPowerRecharge",data)
}
export function monthlyFinanceSummary(data){//钱包月度收支汇总
	return request.get(config.baseApi+"/merchant/user/finance/monthly-summary",data)
}
export function rechargeCampaign(data){//当前算力充值活动
	return request.get(config.baseApi+"/merchant/user/recharge-campaign",data)
}
export function conventionalComputingPowerFinanceList(data){//常规算力流水
    return request.get(config.baseApi+"/merchant/userconventionalcomputingpower/finance/list",data)
}


/**
 * 上架策略
 */
export function celveData(data){//获取上架策略数据
	return request.get(config.baseApi+"/merchant/listing-strategies",data)
}
export function addCelve(data){//新增上架策略
	return request.post(config.baseApi+"/merchant/listing-strategies",data)
}
export function updateCelve(data){//更新上架策略
	return request.put(config.baseApi+`/merchant/listing-strategies/${data.id}`,data)
}
export function delCelve(data){//删除上架策略
	return request.delete(config.baseApi+"/merchant/listing-strategies",data)
}

/**
 * 资源盲盒*/
export function blindBoxList(data){//获取资源盲盒
	return request.get(config.baseApi+"/merchant/shop/shopBlindBox",data)
}
export function doudianApplications(data = {}) {
	return request.get(config.baseApi+"/merchant/shop/doudianApplications",data)
}
export function setDistributionProductApplication(data) {
	return request.post(config.baseApi+"/merchant/shop/distributionProductApplication",data)
}
export function checkDistributionApplication(data) {
	return request.post(config.baseApi+"/merchant/shop/distributionCheck",data)
}
export function blindBoxDetail(data){//获取资源盲盒详情
	return request.get(config.baseApi+"/merchant/shop/shopBlindBoxGet",data)
}
export function saveBlindBox(data){//编辑资源盲盒
	return request.post(config.baseApi+"/merchant/shop/shopBlindBoxSave",data)
}
export function saveBlindBoxResources(data){//编辑盲盒店铺专属资源
	return request.post(config.baseApi+"/merchant/shop/shopBlindBoxResourcesSave",data)
}
export function saveBlindBoxStatus(data){//修改资源盲盒状态
	return request.post(config.baseApi+"/merchant/shop/shopBlindBoxStatus",data)
}
export function blindBoxStrategyList(data){
	return request.get(config.baseApi+"/merchant/blind-box/strategies",data)
}
export function createBlindBoxStrategy(data){
	return request.post(config.baseApi+"/merchant/blind-box/strategies",data)
}
export function updateBlindBoxStrategy(id,data){
	return request.put(config.baseApi+"/merchant/blind-box/strategies/"+id,data)
}
export function bindBlindBoxStrategy(id,data){
	return request.post(config.baseApi+"/merchant/blind-box/strategies/"+id+"/shops",data)
}
export function getBlindBoxStrategy(id){
	return request.get(config.baseApi+"/merchant/blind-box/strategies/"+id)
}
export function getBlindBoxShopCategorySummary(merShopId){
	return request.get(config.baseApi+"/merchant/blind-box/shops/"+encodeURIComponent(merShopId)+"/category-summary")
}
export function getBlindBoxShopSelectedCategories(merShopId,data){
	return request.get(config.baseApi+"/merchant/blind-box/shops/"+encodeURIComponent(merShopId)+"/selected-categories",data)
}
export function getBlindBoxShopBrandCandidates(merShopId,data){
	return request.get(config.baseApi+"/merchant/blind-box/shops/"+encodeURIComponent(merShopId)+"/brand-candidates",data)
}
export function getBlindBoxShopBrandCandidateCategories(merShopId,data){
	return request.get(config.baseApi+"/merchant/blind-box/shops/"+encodeURIComponent(merShopId)+"/brand-candidate-categories",data)
}
export function deleteBlindBoxStrategy(id){
	return request.delete(config.baseApi+"/merchant/blind-box/strategies/"+id)
}
export function batchDeleteBlindBoxStrategies(data){
	return request.post(config.baseApi+"/merchant/blind-box/strategies/batch-delete",data)
}
export function blindBoxStrategyCategoryTree(data){
	return request.get(config.baseApi+"/merchant/blind-box/category-tree",data)
}
export function blindBoxStrategyBlacklistCategoryTree(){
	return request.get(config.baseApi+"/merchant/blind-box/blacklist-category-tree")
}
export function unbindBlindBoxStrategy(merShopId){
	return request.delete(config.baseApi+"/merchant/blind-box/shops/"+merShopId+"/strategy")
}
export function getBrandList(data){//获取品牌列表
	return request.get(config.baseApi+"/merchant/shop/getShopBrandList",data)
}
export function getBrandListBatch(data){//批量获取品牌列表
	return request.get(config.baseApi+"/merchant/shop/getShopBrandListNew",data)
}
export function saveBrand(data){//更新品牌
	return request.post(config.baseApi+"/merchant/shop/saveShopBrand",data)
}
export function categoryList(data){//获取分类列表
	return request.get(config.baseApi+"/merchant/shop/subCategory",data)
}
export function leafCategoryList(data){//获取分类列表（至第三级）
	return request.get(config.baseApi+"/merchant/shop/leafCategory",data)
}
export function wechatCategoryList(data){//获取微信小店分类列表
	return request.get(config.baseApi+"/merchant/shop/getWechatShopCategoryList",data)
}
export function getPhraseList(data){//请求分词接口
	return request.post(config.baseApi+"/merchant/shop/getPhraseList",data)
}
export function getTwoCategorySubList(data){//获取二级类目下级叶子类目
	return request.post(config.baseApi+"/merchant/shop/getTwoCategorySubList",data)
}
export function saveWashingConfiguration(data){//更新水洗标配置
	return request.postJson(config.baseApi+"/merchant/shop/saveWashingConfiguration", data)
}
export function getWashingConfiguration(data){//获取水洗标配置
	return request.get(config.baseApi+"/merchant/shop/getWashingConfiguration",data)
}
/**
 * 个人设置
 */
export function setAvatar(data){//更换头像
	return request.post(config.baseApi+"/business/basinessediticon",data)
}
export function changePhone(data){//换绑手机
	return request.post(config.baseApi+"/business/basinesseditmobile",data)
}
export function changePwd(data){//更改密码
	// return request.post(config.baseApi+"/business/basinesseditpassword",data)
	return request.post(config.baseApi+"/merchant/user/resetPassword",data)
}
export function changeRemind(data){//接收公众号提醒
	return request.post(config.baseApi+"/business/basinesssetwxremind",data)
}
export function changeDecrypt(data){//开启自动解密
	return request.post(config.baseApi+"/business/basinesssetdecrypt",data)
}
export function changeAutoPurchase(data){//开启自动采购
	return request.post(config.baseApi+"/business/changeAutoPurchase",data)
}

export function getSystemToolDownloads(data){//获取系统安装包下载链接
	return request.get(config.baseApi+"/merchant/system-tool-downloads",data)
}

export function decryptLog(data){//解密日志
	return request.get(config.baseApi+"/business/User/decryptLog",data)
}
export function changeAutoPrint(data){//开启自动打单
	return request.post(config.baseApi+"/business/basinesssetautoprintorder",data)
}

/**
 * 推广中心
 */
export function extendUrl(data){//获取推广中心链接
	return request.post(config.baseApi+"/business/basinesstgurl",data)
}
export function extendList(data){//获取推广中心合作列表
	return request.post(config.baseApi+"/business/basinesstglist",data)
}

/**
 * 我的抖店 / 微信店
 */
export function ddShopList(data){//获取我的店铺列表
	return request.get(config.baseApi+"/merchant/shop/list",data)
}
export function addWechatShop(data){//添加微信店铺
	return request.post(config.baseApi+"/merchant/shop/addWechatShop",data)
}
export function getWechatShopAuthCode(data){//通过code获取微信店铺授权信息
	return request.post(config.baseApi+"/merchant/shop/getWechatShopAuthCode",data)
}
export function previewDoudianAuthorizationCodes(data){//预览抖店授权码
	return request.post(config.baseApi+"/merchant/shop/doudianAuthorizationCode/preview",data)
}
export function confirmDoudianAuthorizationCodes(data){//确认通过授权码添加抖店
	return request.post(config.baseApi+"/merchant/shop/doudianAuthorizationCode/confirm",data)
}
export function ddShopDel(data){//删除抖店
	return request.post(config.baseApi+"/business/DdShop/del",data)
}
export function shopLevel(data){//获取抖店等级
	return request.get(config.baseApi+"/merchant/shop/getShopLevelList",data)
}
export function orderMember(data){ //订购会员
	return request.post(config.baseApi+"/merchant/user/orderMember",data)
}
export function getMembershipPlans(data){
	return request.get(config.baseApi+"/merchant/user/level/plans",data)
}
export function getCurrentMembership(data){
	return request.get(config.baseApi+"/merchant/user/level",data)
}
export function purchaseMembership(data){
	return request.post(config.baseApi+"/merchant/user/level/purchase",data)
}
export function closeShop(data){ //关店
	return request.post(config.baseApi+"/merchant/shop/closeShop",data)
}
export function getShopMainCategory(data){ //读取该用户所有盲盒铺货主营类目
	return request.get(config.baseApi+"/merchant/shop/getShopAllMainCategory",data)
}
export function getMerchantAllShopList(data){ //读取该用户所有店铺
	return request.get(config.baseApi+"/merchant/shop/getMerchantAllShopList",data)
}
export function workbenchSummary(){ //星人工作台统计汇总
	return request.get(config.baseApi+"/merchant/workbench/summary")
}
export function accountReminders(data){//账号到期/授权提醒
	return request.post(config.baseApi+"/merchant/Mall/businessNoticeReminders",data)
}
export function lowSalesProductDeleteAuthorization(data){//低效品删除授权
	return request.post(config.baseApi+"/merchant/shop/lowSalesProductDeleteAuthorization",data)
}
export function resetResourceState(data){//重置素材容量不足状态
	return request.post(config.baseApi+"/merchant/DdShop/resetResourceState",data)
}
export function getBusinessUserId(data) {//当前商家 business_user_id
	return request.get(config.baseApi + "/merchant/userGetBusinessUserId", data)
}

/**
 * 我的商品
 */
export function goodsFilterData(data){//获取商品筛选数据
	return request.get(config.baseApi+"/business/DdProduct/filter_data",data)
}
export function goodsList(data){//获取商品列表
	// return request.get(config.baseApi+"/business/DdProduct/list",data)
	return request.get(config.baseApi+"/merchant/distribute/products/list",data)
}
export function goodsStatusStatistics(data){//获取商品状态统计
	return request.get(config.baseApi+"/merchant/distribute/products/status-statistics",data)
}
export function goodsCloudSource(id){//获取铺货商品对应云商品来源ID
	return request.get(config.baseApi+`/merchant/distribute/products/${id}/cloud-source`)
}
export function doudianProductEditDetail(id){//获取抖店商品编辑详情
	return request.get(config.baseApi+`/merchant/doudian-products/${id}/edit-detail`)
}
export function saveDoudianProductEdit(id, data){//保存抖店商品编辑
	return request.put(config.baseApi+`/merchant/doudian-products/${id}`, data)
}
export function predictDoudianProductCategory(id, data){//预测抖店商品类目
	return request.post(config.baseApi+`/merchant/doudian-products/${id}/category-predictions`, data)
}
export function doudianProductFreightTemplates(id, data){//获取抖店运费模板
	return request.get(config.baseApi+`/merchant/doudian-products/${id}/freight-templates`, data)
}
export function doudianProductBrands(id, data){//获取抖店类目品牌
	return request.get(config.baseApi+`/merchant/doudian-products/${id}/brands`, data)
}
export function doudianProductCategoryProperties(id, data){//获取抖店类目属性
	return request.get(config.baseApi+`/merchant/doudian-products/${id}/category-properties`, data)
}
export function doudianProductUpdateRule(id, data){//获取抖店商品编辑规则
	return request.get(config.baseApi+`/merchant/doudian-products/${id}/update-rule`, data)
}
export function doudianProductSizeTemplates(id, data){//获取抖店尺码模板
	return request.get(config.baseApi+`/merchant/doudian-products/${id}/size-templates`, data)
}
export function doudianProductMaterialFolders(id, data){//获取抖店素材文件夹
	return request.get(config.baseApi+`/merchant/doudian-products/${id}/material/folders`, data)
}
export function doudianProductMaterialFolderFiles(id, data){//获取抖店素材文件夹图片
	return request.get(config.baseApi+`/merchant/doudian-products/${id}/material/folder-files`, data)
}
export function doudianProductMaterialDetail(id, data){//查询抖店素材详情
	return request.get(config.baseApi+`/merchant/doudian-products/${id}/material/detail`, data)
}
export function doudianProductMaterialOssUploadToken(id, data){//获取抖店素材OSS直传授权
	return request.get(config.baseApi+`/merchant/doudian-products/${id}/material/oss-upload-token`, data)
}
export function uploadDoudianProductMaterialImage(id, data){//上传图片到抖店素材库
	return request.post(config.baseApi+`/merchant/doudian-products/${id}/material/upload-image`, data)
}
export function uploadDoudianProductMaterialVideo(id, data){//上传视频到抖店素材库
	return request.post(config.baseApi+`/merchant/doudian-products/${id}/material/upload-video`, data)
}
export function recycleDoudianProductMaterialFolderFiles(id, data){//一键移入回收站当前目录素材
	return request.post(config.baseApi+`/merchant/doudian-products/${id}/material/easy-shuttle`, data)
}

export function goodsListSecond(data){//获取二次谈价商品列表
	return request.get(config.baseApi+"/business/DdProduct/listSecond",data)
}

export function saleConfigSave(data){//二次谈价销量配置保存
	return request.post(config.baseApi+"/business/DdProduct/saleConfigSave",data)
}
export function batOnSale(data){//批量上架商品
	return request.post(config.baseApi+"/business/DdProduct/bat_on_sale",data)
}
export function batOffSale(data){//批量下架商品
	return request.post(config.baseApi+"/business/DdProduct/bat_off_sale",data)
}
export function batProductEdit(data){//商品批量改价
	return request.post(config.baseApi+"/business/DdProduct/bat_product_edit",data)
}
export function productDel(data){//删除商品
	return request.post(config.baseApi+"/business/DdProduct/del",data)
}
export function batProductDel(data){//删除商品
	return request.post(config.baseApi+"/business/DdProduct/bat_del",data)
}
export function productEditUrl(data){//获取url
	return request.post(config.baseApi+"/business/Edit/getProductEditUrl",data)
}
export function deleteAllurl(data){//批量删除
	return request.post(config.baseApi+"/business/DdProduct/allDeleteProduct",data)
}

export function shopEditUrl(data){//获取url
	return request.post(config.baseApi+"/business/Edit/getShopEditUrl",data)
}
export function getAuthSuccessShopList(){//获取授权正常的店铺列表
	return request.get(config.baseApi+"/merchant/shop/getAuthSuccessShopList")
}
export function getShopProductSuggestionList(data){//查询店铺诊断商品列表及其处理建议
	return request.get(config.baseApi+"/merchant/shop/getShopProductSuggestionList",data)
}

/**
 * 商品关联
 */
export function goodsRelativeInfoData(data){//获取关联商品信息
	return request.get(config.baseApi+"/business/DdProduct/relativeInfo",data)
}
export function checkoutSkuRelative(data){//关联商品检出变动订单数、金额
	return request.post(config.baseApi+"/business/DdProduct/checkoutSkuRelative",data)
}
export function goodsConfigData(data){//获取关联商品规格
	return request.get(config.baseApi+"/business/DdProduct/productSku",data)
}
export function submitRelative(data){//获取关联商品规格
	return request.post(config.baseApi+"/business/DdProduct/subSkuRelative",data)
}
export function similarGoodsData(data){//搜索同款商品
	return request.get(config.baseApi+"/business/DdProduct/searchProduct",data)
}
export function syncProduct(data){//一键同步商品
	return request.post(config.baseApi+"/business/DdProduct/syncProduct",data)
}
export function syncDistributeDoudianProducts(data){//商家端抖店商品一键同步
	return request.post(config.baseApi+"/merchant/distribute/products/doudian-sync",data)
}
export function syncDistributeWechatProducts(data){//商家端微店商品一键同步
	return request.post(config.baseApi+"/merchant/distribute/products/wechat-sync",data)
}
export function doudianMoveConfigDetail(shopId){
	return request.get(config.baseApi+`/merchant/doudian-move-config/shops/${shopId}`)
}
export function doudianMoveTemplateCreate(shopId,data){
	return request.post(config.baseApi+`/merchant/doudian-move-config/shops/${shopId}/templates`,data)
}
export function doudianMoveTemplateRename(templateId,data){
	return request.put(config.baseApi+`/merchant/doudian-move-config/templates/${templateId}`,data)
}
export function doudianMoveTemplateSetDefault(templateId){
	return request.put(config.baseApi+`/merchant/doudian-move-config/templates/${templateId}/default`,{})
}
export function doudianMoveTemplateDelete(templateId){
	return request.delete(config.baseApi+`/merchant/doudian-move-config/templates/${templateId}`)
}
export function doudianMoveTemplateCategoryConfigsClear(templateId){
	return request.delete(config.baseApi+`/merchant/doudian-move-config/templates/${templateId}/category-configs`)
}
export function doudianMoveCategorySync(shopId){
	return request.post(config.baseApi+`/merchant/doudian-move-config/shops/${shopId}/category-sync`,{})
}
export function doudianMoveCategorySyncTask(taskId){
	return request.get(config.baseApi+`/merchant/doudian-move-config/category-sync-tasks/${taskId}`)
}
export function doudianMoveCategories(shopId,data){
	return request.get(config.baseApi+`/merchant/doudian-move-config/shops/${shopId}/categories`,data)
}
export function doudianMoveCategoryProperties(templateId,categoryId){
	return request.get(config.baseApi+`/merchant/doudian-move-config/templates/${templateId}/categories/${categoryId}/properties`)
}
export function doudianMoveCategoryConfigSave(templateId,categoryId,data){
	return request.put(config.baseApi+`/merchant/doudian-move-config/templates/${templateId}/categories/${categoryId}`,data)
}
export function doudianMoveCategoryConfigClear(templateId,categoryId){
	return request.delete(config.baseApi+`/merchant/doudian-move-config/templates/${templateId}/categories/${categoryId}`)
}
export function doudianMoveCategoryInstallation(templateId,categoryId){
	return request.get(config.baseApi+`/merchant/doudian-move-config/templates/${templateId}/categories/${categoryId}/installation`)
}
export function doudianMoveCategoryInstallationSave(templateId,categoryId,data){
	return request.put(config.baseApi+`/merchant/doudian-move-config/templates/${templateId}/categories/${categoryId}/installation`,data)
}
export function doudianMoveCategoryInstallationClear(templateId,categoryId){
	return request.delete(config.baseApi+`/merchant/doudian-move-config/templates/${templateId}/categories/${categoryId}/installation`)
}
export function doudianMoveTemplateInstallation(templateId){
	return request.get(config.baseApi+`/merchant/doudian-move-config/templates/${templateId}/installation`)
}
export function doudianMoveTemplateInstallationSave(templateId,data){
	return request.put(config.baseApi+`/merchant/doudian-move-config/templates/${templateId}/installation`,data)
}
export function doudianMoveTemplatePricing(templateId){
	return request.get(config.baseApi+`/merchant/doudian-move-config/templates/${templateId}/pricing`)
}
export function doudianMoveTemplatePricingSave(templateId,data){
	return request.put(config.baseApi+`/merchant/doudian-move-config/templates/${templateId}/pricing`,data)
}
export function doudianMoveTemplateImageSettings(templateId){
	return request.get(config.baseApi+`/merchant/doudian-move-config/templates/${templateId}/image-settings`)
}
export function doudianMoveTemplateImageSettingsSave(templateId,data){
	return request.put(config.baseApi+`/merchant/doudian-move-config/templates/${templateId}/image-settings`,data)
}
export function doudianMoveGlobalCategoryProperties(shopId,categoryId){
	return request.get(config.baseApi+`/merchant/doudian-move-config/shops/${shopId}/global-categories/${categoryId}/properties`)
}
export function doudianMoveGlobalCategoryConfigSave(shopId,categoryId,data){
	return request.put(config.baseApi+`/merchant/doudian-move-config/shops/${shopId}/global-categories/${categoryId}`,data)
}
export function doudianMoveGlobalCategoryConfigClear(shopId,categoryId){
	return request.delete(config.baseApi+`/merchant/doudian-move-config/shops/${shopId}/global-categories/${categoryId}`)
}
export function doudianMoveGlobalConfigPreview(templateId){
	return request.get(config.baseApi+`/merchant/doudian-move-config/templates/${templateId}/global-config-preview`)
}
export function doudianMoveGlobalConfigImport(templateId,data){
	return request.post(config.baseApi+`/merchant/doudian-move-config/templates/${templateId}/global-config-import`,data)
}
export function doudianMoveTemplateSyncTargets(templateId){
	return request.get(config.baseApi+`/merchant/doudian-move-config/templates/${templateId}/sync-targets`)
}
export function doudianMoveTemplateSync(templateId,data){
	return request.post(config.baseApi+`/merchant/doudian-move-config/templates/${templateId}/sync`,data)
}
export function wechatMoveConfigDetail(shopId){
	return request.get(config.baseApi+`/merchant/wechat-move-config/shops/${shopId}`)
}
export function wechatMoveTemplateCreate(shopId,data){
	return request.post(config.baseApi+`/merchant/wechat-move-config/shops/${shopId}/templates`,data)
}
export function wechatMoveTemplatePricing(templateId){
	return request.get(config.baseApi+`/merchant/wechat-move-config/templates/${templateId}/pricing`)
}
export function wechatMoveTemplatePricingSave(templateId,data){
	return request.put(config.baseApi+`/merchant/wechat-move-config/templates/${templateId}/pricing`,data)
}
export function wechatMoveTemplateImageSettings(templateId){
	return request.get(config.baseApi+`/merchant/wechat-move-config/templates/${templateId}/image-settings`)
}
export function wechatMoveTemplateImageSettingsSave(templateId,data){
	return request.put(config.baseApi+`/merchant/wechat-move-config/templates/${templateId}/image-settings`,data)
}
export function wechatMoveTemplateRename(templateId,data){
	return request.put(config.baseApi+`/merchant/wechat-move-config/templates/${templateId}`,data)
}
export function wechatMoveTemplateSetDefault(templateId){
	return request.put(config.baseApi+`/merchant/wechat-move-config/templates/${templateId}/default`,{})
}
export function wechatMoveTemplateDelete(templateId){
	return request.delete(config.baseApi+`/merchant/wechat-move-config/templates/${templateId}`)
}
export function wechatMoveTemplateCategoryConfigsClear(templateId){
	return request.delete(config.baseApi+`/merchant/wechat-move-config/templates/${templateId}/category-configs`)
}
export function wechatMoveCategories(shopId,data){
	return request.get(config.baseApi+`/merchant/wechat-move-config/shops/${shopId}/categories`,data)
}
export function wechatMoveCategoriesRefresh(shopId){
	return request.post(config.baseApi+`/merchant/wechat-move-config/shops/${shopId}/categories/refresh`,{})
}
export function wechatMoveCategoryProperties(templateId,categoryId){
	return request.get(config.baseApi+`/merchant/wechat-move-config/templates/${templateId}/categories/${categoryId}/properties`)
}
export function wechatMoveCategoryConfigSave(templateId,categoryId,data){
	return request.put(config.baseApi+`/merchant/wechat-move-config/templates/${templateId}/categories/${categoryId}`,data)
}
export function wechatMoveCategoryConfigClear(templateId,categoryId){
	return request.delete(config.baseApi+`/merchant/wechat-move-config/templates/${templateId}/categories/${categoryId}`)
}
export function wechatMoveGlobalCategoryProperties(shopId,categoryId){
	return request.get(config.baseApi+`/merchant/wechat-move-config/shops/${shopId}/global-categories/${categoryId}/properties`)
}
export function wechatMoveGlobalCategoryConfigSave(shopId,categoryId,data){
	return request.put(config.baseApi+`/merchant/wechat-move-config/shops/${shopId}/global-categories/${categoryId}`,data)
}
export function wechatMoveGlobalCategoryConfigClear(shopId,categoryId){
	return request.delete(config.baseApi+`/merchant/wechat-move-config/shops/${shopId}/global-categories/${categoryId}`)
}
export function wechatMoveGlobalConfigPreview(templateId){
	return request.get(config.baseApi+`/merchant/wechat-move-config/templates/${templateId}/global-config-preview`)
}
export function wechatMoveGlobalConfigImport(templateId,data){
	return request.post(config.baseApi+`/merchant/wechat-move-config/templates/${templateId}/global-config-import`,data)
}
export function wechatMoveTemplateSyncTargets(templateId){
	return request.get(config.baseApi+`/merchant/wechat-move-config/templates/${templateId}/sync-targets`)
}
export function wechatMoveTemplateSync(templateId,data){
	return request.post(config.baseApi+`/merchant/wechat-move-config/templates/${templateId}/sync`,data)
}
export function goodsSkuChangeLog(data){//一键同步商品
	return request.post(config.baseApi+"/business/DdProduct/skuChangeLog",data)
}

/**
 * 订单管理
 */
export function orderManageList(data){//获取我的订单列表
	return request.get(config.baseApi+"/business/OrderManage/list",data)
}

export function orderManageCutList(data){//获取拦截订单列表
	return request.get(config.baseApi+"/business/OrderManage/listCut",data)
}

export function orderManageAddressInfo(data){//查看收货人信息
	return request.get(config.baseApi+"/business/OrderManage/addressInfo",data)
}
export function orderManageShopList(data){//商家店铺列表
	return request.get(config.baseApi+"/business/OrderManage/shopList",data)
}
export function editSyncOrderQueue(data){//商家同步历史订单
	return request.post(config.baseApi+"/business/OrderManage/editSyncOrderQueue",data)
}
export function orderManageDetail(data){//订单详情
	return request.get(config.baseApi+"/business/OrderManage/detail",data)
}
export function orderManageFilterData(data){//获取订单筛选数据
	return request.get(config.baseApi+"/business/OrderManage/filterData",data)
}
export function orderManageBatPurchase(data){//手动批量采购
	return request.get(config.baseApi+"/business/OrderManage/batPurchase",data)
}
export function orderManageBatAbnormal(data){//批量标记异常
	return request.post(config.baseApi+"/business/OrderManage/batAbnormal",data)
}
export function orderManageBatIntercept(data){//批量设置拦截
	return request.post(config.baseApi+"/business/OrderManage/batIntercept",data)
}
export function orderManageChangeSku(data){//关联商品
	return request.post(config.baseApi+"/business/OrderManage/changeOrderSku",data)
}
export function orderManageCheckoutChangeSku(data){//修改关联商品计算变动订单数、金额
	return request.post(config.baseApi+"/business/OrderManage/checkoutChangeSku",data)
}
export function orderManageRemarkInfo(data){//订单标记备注信息
	return request.get(config.baseApi+"/business/OrderManage/remarkInfo",data)
}
export function orderManageAddRemark(data){//添加备注和旗子
	return request.post(config.baseApi+"/business/OrderManage/addRemark",data)
}
export function orderManageServiceRemarkInfo(data){//订单客服备注信息
	return request.get(config.baseApi+"/business/OrderManage/serviceRemarkInfo",data)
}
export function orderManageAddServiceRemark(data){//添加客服备注
	return request.post(config.baseApi+"/business/OrderManage/addServiceRemark",data)
}
export function orderManageReceipt(data){//确认收货
	return request.post(config.baseApi+"/business/OrderManage/receipt",data)
}
export function orderManagePurchaseCancel(data){//取消采购
	return request.post(config.baseApi+"/business/OrderManage/purchase_cancel",data)
}
export function orderManageOrderCancel(data){//取消订单
	return request.post(config.baseApi+"/business/OrderManage/order_cancel",data)
}
export function getOrderProductList(data){
	return request.post(config.baseApi+"/business/OrderManage/orderProductList",data)
}
export function getRelativeProductList(data){
	return request.post(config.baseApi+"/business/DdProduct/relative_product_list",data)
}
export function ddShopRefreshDecrypt(data){//提额成功更新店铺状态
	return request.get(config.baseApi+"/business/DdShop/refreshDecrypt",data)
}
export function unDecrypt(data){//商品同步
	return request.get(config.baseApi+"/business/OrderManage/syncSingleProduct",data)
}
export function reDecrypt(data){//恢复解密
	return request.get(config.baseApi+"/business/OrderManage/reDecrypt",data)
}
export function baseConfig(data){//系统设置
	return request.get(config.baseApi+"/business/User/baseConfig",data)
}
export function checkPrintRecharge(data){//查询充值打单情况
	return request.post(config.baseApi+"/business/User/checkPrintRecharge",data)
}
export function editPrintProduct(data){//编辑打单商品配置
	return request.post(config.baseApi+"/business/User/editPrintProduct",data)
}
export function businessRoleIndex(data){//岗位管理列表
	return request.get(config.baseApi+"/merchant/userSubRole/pageList",data)
}
export function businessRoleMenus(data){//权限系统获取菜单
	return request.post(config.baseApi+"/business/System.Businessrole/getRoleMenus",data)
}
export function businessRoleAdd(data){//添加岗位
	return request.post(config.baseApi+"/merchant/userSubRole/create",data)
}
export function businessRoleUpdate(data){//更新岗位设置
	return request.put(config.baseApi+"/merchant/userSubRole/update",data)
}
export function businessRoleDel(data){//删除岗位
	return request.delete(config.baseApi+"/merchant/userSubRole/delete",data)
}
export function businessRoleInfo(data){//岗位信息
	return request.get(config.baseApi+"/merchant/userSubRole/getInfo",data)
}
export function businessRoleExt(data){//岗位禁用状态
	return request.post(config.baseApi+"/business/System.Businessrole/updateExt",data)
}
export function agentuserIndex(data){//员工列表
	return request.get(config.baseApi+"/merchant/userSub/pageList",data)
}
export function agentuserFieldList(data){//获取岗位信息
	return request.get(config.baseApi+"/merchant/userSubRole/pageList",data)
}
export function agentuserAdd(data){//添加员工
	return request.post(config.baseApi+"/merchant/userSub/create",data)
}
export function agentuserDel(data){//删除员工
	return request.post(config.baseApi+"/merchant/userSub/delete",data)
}
export function agentuserInfo(data){//查询员工修改信息
	return request.post(config.baseApi+"/business/System.Agentuser/getUpdateInfo",data)
}
export function agentuserUpdate(data){//更新员工
	return request.post(config.baseApi+"/merchant/userSub/update",data)
}
export function agentuserResetPwd(data){//重置密码
	return request.post(config.baseApi+"/business/System.Agentuser/resetPwd",data)
}
export function agentuserExt(data){//修改员工显示状态
	return request.post(config.baseApi+"/business/System.Agentuser/updateExt",data)
}
export function productDicker(data){//商品谈价
	return request.post(config.baseApi+"/business/DdProduct/productdicker",data)
}
export function productDickerHistory(data){//商品谈价历史
	return request.get(config.baseApi+"/business/DdProduct/productdickerHistory",data)
}
export function collectList(data){//档口收藏列表
	return request.get(config.baseApi+"/business/Collect/list",data)
}
export function collectCancel(data){//档口收藏取消
	return request.post(config.baseApi+"/business/Collect/collectCancel",data)
}
export function packageList(data){//获取可充值的套餐
	return request.get(config.baseApi+"/merchant/user/quotaPackageList",data)
}
export function packageRecharge(data){//充值
	return request.post(config.baseApi+"/merchant/user/quotaRecharge",data)
}
export function packageCheckOrder(data){//充值判断
	return request.post(config.baseApi+"/business/quota/check_order",data)
}
export function quotaList(data){//充值记录
	return request.post(config.baseApi+"/business/quota/list",data)
}
export function getAfterSaleFilterData(data){//获取售后筛选数据
	return request.post(config.baseApi + "/business/OrderManage/filterReturnData", data)
}
export function getAfterSaleList(data){//获取售后列表
	return request.post(config.baseApi + "/business/OrderManage/afterSalesList", data)
}
export function getAfterSaleDetail(data){//获取售后详情
	return request.post(config.baseApi + "/business/OrderManage/aftersale_detail", data)
}
export function queryDelivery(data){//查询物流信息
	return request.post(config.baseApi + "/business/OrderManage/query_delivery", data)
}
export function logisticsForwarding(data){//查询物流信息
	return request.post(config.baseApi + "/business/OrderManage/logistics_forwarding", data)
}
export function getLogistics(data){//获取物流公司列表
	return request.post(config.baseApi + "/business/OrderManage/get_logistics", data)
}
export function returnApplication(params) {
	return request.post('/business/OrderManage/returnApplication', params)
}
export function returnLogistics(params) {//获取回寄物流信息
	return request.post('/business/OrderManage/returnApplication', params)
}
export function leadintoApi(data){//导入商品
	return request.post(config.baseApi+"/business/DdProduct/import_delete_products",data)
}
export function freightTemplateList(data) {
	return request.get(config.baseApi + "/business/Order/template_list", data)
}
export function authorizeOperate(data) {
	return request.post(config.baseApi + "/business/Order/authorize_operate", data)
}
export function expressDelivery(data){//设置快递类型
	return request.post(config.baseApi+"/business/Order/express_delivery",data)
}
export function autoBatchPurchase(data){//设置快递类型
	return request.post(config.baseApi+"/business/orderManage/autoBatchPurchase",data)
}
export function exportBasinessJineFlow(data){//设置快递类型
	return request.post(config.baseApi+"/business/Mywallet/basinessJineFlow",data)
}
export function productsOperation(data){//我的商品操作
	return request.post(config.baseApi+"/merchant/distribute/products/operation",data)
}
export function getProductsOperationTask(taskId){
	return request.get(config.baseApi+`/merchant/distribute/products/operation-tasks/${taskId}`)
}
export function generateCheckCode(){//获取授权code
	return request.get(config.baseApi+"/merchant/user/generateCheckCode")
}
/**
 * 云商品库
 */
export function importList(data){//获取导入批次列表
	return request.get(config.baseApi+"/merchant/product/import/list",data)
}
export function importCreate(data){//创建商品导入批次
	return request.post(config.baseApi+"/merchant/product/import/create",data)
}
export function importCreate1688(data){//创建1688商品导入
	return request.post(config.baseApi+"/merchant/product/import/create1688",data)
}
export function importCreatePackage(data){//创建OSS数据包商品导入
	return request.post(config.baseApi+"/merchant/product/import/package/create",data)
}
export function importDetail(data){//获取批次详情
	return request.get(config.baseApi+"/merchant/product/import/detail",data)
}
export function importItems(data){//获取批次明细列表
	return request.get(config.baseApi+"/merchant/product/import/items",data)
}
export function importCancel(data){//取消导入批次
	return request.post(config.baseApi+"/merchant/product/import/cancel",data)
}
export function distributeShopSel(data){//获取导入批次的店铺选择情况
	return request.get(config.baseApi+"/merchant/distribute/shop-selection",data)
}
export function distributeBatch(data){//创建店铺铺货
	return request.post(config.baseApi+"/merchant/distribute/batch/create",data)
}

/**
 * 云商品列表模块
 */
export function cloudProductList(data){//获取导入商品列表（跨批次）
	return request.get(config.baseApi+"/merchant/distribute/import-products",data)
}
export function cloudProductDistributeRecords(id){//获取云商品铺货日志
	return request.get(config.baseApi+`/merchant/distribute/import-products/${id}/distribute-records`)
}
export function cloudProductViolations(id, data){//获取云商品关联的违规记录
	return request.get(config.baseApi+`/merchant/distribute/import-products/${id}/violations`, data)
}
export function cloudProductEditDetail(id){//获取云商品编辑详情
	return request.get(config.baseApi+`/merchant/distribute/import-products/${id}/edit-detail`)
}
export function cloudProductFreightDetails(id, data){//获取云商品各省首件运费
	return request.get(config.baseApi+`/merchant/distribute/import-products/${id}/freight-details`, data)
}
export function cloudProductEditSave(id, data){//保存云商品编辑
	return request.put(config.baseApi+`/merchant/distribute/import-products/${id}/edit`,data)
}
export function cloudProductEditSaveV2(id, data){//新版差异化保存云商品编辑
	return request.put(config.baseApi+`/merchant/distribute/import-products/${id}/edit-v2`,data)
}
export function batchUpdateCloudProductTimeTags(data){//批量设置云商品时效标签
	return request.put(config.baseApi+"/merchant/distribute/import-products/batch-time-tags",data)
}
export function deleteCloudProduct(data){//删除云商品
	return request.post(config.baseApi+"/merchant/distribute/import-products/batch-delete",data)
}
export function imageSearch(data){//以图搜款
	return request.get(config.baseApi+"/merchant/distribute/import-products/image-search",data)
}
export function replaceCloudProducts(data){//批量替换云商品
	return request.post(config.baseApi+"/merchant/distribute/import-products/replace",data)
}
export function markCloudProducts(data){
	return request.post(config.baseApi+"/merchant/distribute/import-products/mark",data)
}
export function productMarkable(data){
	return request.get(config.baseApi+"/merchant/distribute/import-products/markable", data)
}
export function redistributeProducts(data){//我的商品：失败商品重铺至原店铺
	return request.post(config.baseApi+"/merchant/distribute/products/redistribute",data)
}
export function cloudProductDistribute(data){//按商品ID铺货到店铺
	// 复用现有的批次铺货接口，传递商品ID数组
	return request.post(config.baseApi+"/merchant/distribute/batch/create",data)
}
export function distributeItems(data){//获取铺货列表
	return request.get(config.baseApi+"/merchant/distribute/items",data)
}
export function recoverCloudProduct(data){//批量恢复检测下架商品
	return request.post(config.baseApi+"/merchant/distribute/import-products/batch-recover-success",data)
}
export function skuMarkNotFound(data){//SKU标记找不到
	return request.post(config.baseApi+"/merchant/distribute/import-products/sku-mark-not-found",data)
}
export function skuCancelNotFound(data){//SKU标记待替换
	return request.post(config.baseApi+"/merchant/distribute/import-products/sku-mark-not-found-cancel",data)
}
export function productMarkNotFound(data){
	return request.post(config.baseApi+"/merchant/distribute/import-products/product-mark-not-found",data)
}
export function productMarkNotFoundCancel(data){
	return request.post(config.baseApi+"/merchant/distribute/import-products/product-mark-not-found-cancel",data)
}
export function replaceLogList(data){//获取替换日志列表
	return request.get(config.baseApi+"/merchant/distribute/import-products/replace-logs",data)
}
export function shareCloudProductList(data){//获取共享商品列表
	return request.get(config.baseApi+"/merchant/distribute/getSharedCloudProductLibrary",data)
}
export function shareCloudGroupsList(data){//获取共享商品列表
	return request.get(config.baseApi+"/merchant/distribute/getSharedCloudGroups",data)
}
export function getCategoryRecommend(data){//获取类目推荐列表
	return request.post(config.baseApi+"/merchant/distribute/category-recommend",data)
}

/**
 * 云商品分组
 */
export function cloudProductGroups(data){//获取分组列表
	return request.get(config.baseApi+"/merchant/cloud-product/groups",data)
}
export function cloudProductGroupsNew(data){//获取分组列表
	return request.get(config.baseApi+"/merchant/cloud-product/groups-new",data)
}
export function cloudProductGroupParents(data){//分页获取主分组
	return request.get(config.baseApi+"/merchant/cloud-product/groups/parents",data)
}
export function cloudProductGroupChildren(parentId, data){//分页获取子分组
	return request.get(config.baseApi+"/merchant/cloud-product/groups/"+parentId+"/children",data)
}
export function cloudProductGroupCreate(data){//创建分组
	return request.post(config.baseApi+"/merchant/cloud-product/groups",data)
}
export function cloudProductGroupUpdate(id, data){//更新分组
	return request.put(config.baseApi+"/merchant/cloud-product/groups/"+id,data)
}
export function cloudProductGroupMove(id, data){//上下移动分组
	return request.put(config.baseApi+"/merchant/cloud-product/groups/"+id+"/move",data)
}
export function cloudProductGroupDelete(id){//删除分组
	return request.delete(config.baseApi+"/merchant/cloud-product/groups/"+id)
}
export function cloudProductBatchSetGroup(data){//批量加入分组
	return request.post(config.baseApi+"/merchant/cloud-product/batch-set-group",data)
}
export function doudianCloudSyncTasks(data){//抖店同步任务列表
	return request.get(config.baseApi+"/merchant/cloud-product/doudian-sync/tasks",data)
}
export function doudianCloudSyncCreate(data){//创建抖店同步任务
	return request.post(config.baseApi+"/merchant/cloud-product/doudian-sync/tasks",data)
}
export function doudianCloudSyncDetail(id){//抖店同步任务详情
	return request.get(config.baseApi+`/merchant/cloud-product/doudian-sync/tasks/${id}`)
}
/**
 * 关键词
 */
export function keywordList(data){//获取关键词列表
	return request.get(config.baseApi+"/merchant/product/keyword/pageList",data)
}
export function keywordAdd(data){//添加关键词
	return request.post(config.baseApi+"/merchant/product/keyword",data)
}
export function keywordDelete(data){//删除关键词
	return request.delete(config.baseApi+"/merchant/product/keyword",data)
}
export function submitDetection(data){//提交关键词检测
	return request.post(config.baseApi+"/merchant/detection/batch/submitDetection",data)
}
export function detectionList(data){//关键词检测记录
	return request.get(config.baseApi+"/merchant/detection/batch/pageList",data)
}
export function stopDetection(data){//终止关键词检测
	return request.post(config.baseApi+"/merchant/detection/batch/stopDetection",data)
}
export function detectionItemList(data){//关键词检测详情
	return request.get(config.baseApi+"/merchant/detection/batch/itemPageList",data)
}
export function detectionBatchOperation(data){//批量操作异常商品 2过滤 3下架 4正常
	return request.post(config.baseApi+"/merchant/detection/batch/batchOperation",data)
}
export function imgKeywordList(data){//获取图片关键词列表
	return request.get(config.baseApi+"/merchant/image/keyword/pageList",data)
}
export function imgKeywordAdd(data){//添加图片关键词
	return request.post(config.baseApi+"/merchant/image/keyword",data)
}
export function imgKeywordDelete(data){//删除图片关键词
	return request.delete(config.baseApi+"/merchant/image/keyword",data)
}
export function imgDetectionList(data){//图片检测列表
	return request.get(config.baseApi+"/merchant/image/detection/pageList",data)
}
export function productImagesList(data){//图片列表
	return request.post(config.baseApi+"/merchant/image/detection/getProductImagesList",data)
}
export function submitImageData(data){//提交图片检测
	return request.post(config.baseApi+"/merchant/image/detection/submitData",data)
}
export function submitImageDataManual(data){//提交图片人工检测
	return request.post(config.baseApi+"/merchant/image/detection/submitDataManual",data)
}
export function submitBatchDetection(data){//提交图片常规检测
	return request.post(config.baseApi+"/merchant/image/detection/submitDetection",data)
}
export function submitAiDetection(data){//提交图片AI检测
	return request.post(config.baseApi+"/merchant/image/detection/submitAiDetection",data)
}
export function imgDetectionTask(data){//图片检测任务列表
	return request.get(config.baseApi+"/merchant/image/detection/batch/pageList",data)
}
export function getPredictSinglePowerNum(data){//获取单个算力值
	return request.post(config.baseApi+"/merchant/image/detection/getPredictSinglePowerNum",data)
}
export function stopImgDetection(data){//终止图片检测任务
	return request.post(config.baseApi+"/merchant/image/detection/batch/stopDetection",data)
}
export function startImgDetection(data){//启动图片检测任务
	return request.post(config.baseApi+"/merchant/image/detection/batch/startBatchDetection",data)
}
export function pauseImgDetection(data){//暂停图片检测任务
	return request.post(config.baseApi+"/merchant/image/detection/batch/pauseDetection",data)
}
export function alienDetectionList(data){//星人鉴图列表
	return request.get(config.baseApi+"/merchant/image/detection/item/itemPageList",data)
}
export function alienDetectionList2(data){//星人鉴图列表2
	return request.get(config.baseApi+"/merchant/image/detection/item/itemPageListNew",data)
}
export function alienDetectionDetail(data){//星人鉴图详情
	return request.post(config.baseApi+"/merchant/image/detection/detail/detailList",data)
}
export function alienDetectionDetail2(data){//星人鉴图详情2
	return request.post(config.baseApi+"/merchant/image/detection/detail/detailListNew",data)
}
export function alienDetectionDel(data){//删除主图or详情图
	return request.post(config.baseApi+"/merchant/image/detection/detail/detailDelete",data)
}
export function updateAppraisalStatus(data){//修改鉴图状态
	return request.post(config.baseApi+"/merchant/image/detection/item/updateAppraisalStatus",data)
}
export function alienBatchOperation(data){//批量下架
	return request.get(config.baseApi+"/merchant/image/detection/item/batchOperation",data)
}
export function alienDetailMark(data){//标记图片正常、违规
	return request.post(config.baseApi+"/merchant/image/detection/detail/detailMark",data)
}
export function alienDetailDelBatch(data){//批量删除图片
	return request.post(config.baseApi+"/merchant/image/detection/detail/detailDeleteBatch",data)
}
export function alienDetailDelDesignate(data){//删除指定违规
	return request.post(config.baseApi+"/merchant/image/detection/detail/detailDeleteDesignate",data)
}
export function alienItemDelDesignateAll(data){//删除所有商品某项违规
	return request.post(config.baseApi+"/merchant/image/detection/item/itemDeleteDetailDesignate",data)
}
export function alienDelMarkAll(data){//删除所有标记的图片
	return request.post(config.baseApi+"/merchant/image/detection/item/itemDeleteDetailMark",data)
}
export function alienSystemDelProgress(data){//系统删除进度
	return request.post(config.baseApi+"/merchant/image/detection/item/systemDeleteProgress",data)
}

/**
 * 低价sku引流检测
 * */
export function skudetectionForecast(data) {//低价sku引流检测预估商品数量
    return request.get(config.baseApi + "/merchant/skudetection/batch/skudetectionForecast", data)
}
export function skudetectionSubmit(data) {//低价sku引流检测提交
    return request.post(config.baseApi + "/merchant/skudetection/batch/submitDetection", data)
}
export function getSkudetectionPage(data) {//低价sku引流检测列表查询
    return request.get(config.baseApi + "/merchant/skudetection/batch/pageList", data)
}
export function getSkudetectionDetailPage(data) {//低价sku引流检测违规详情列表查询
    return request.get(config.baseApi + "/merchant/skudetection/detail/pageList", data)
}
export function delSkudetectionDetail(data) {//低价sku引流检测违规删除
    return request.delete(config.baseApi + "/merchant/skudetection/detail/delete", data)
}
export function putSkudetectionDetail(data) {//低价sku引流检测违规删除
    return request.put(config.baseApi + "/merchant/skudetection/detail/updatestatus", data)
}
export function offlineSkudetection(data) {//下架低价sku引流检测违规的商品
    return request.post(config.baseApi + "/merchant/skudetection/detail/offline", data)
}
export function getViolationWords(data) {//低价sku引流读取违规词
    return request.get(config.baseApi + "/merchant/skudetection/detail/violationwords", data)
}
export function putReplaceSkuName(data) {//低价sku引流检测违规词过滤
    return request.put(config.baseApi + "/merchant/skudetection/detail/replaceskuname", data)
}
export function putEditsku(data) {//修改低价sku
    return request.put(config.baseApi + `/merchant/skudetection/detail/editsku/${data.id}`, data)
}
/**
 *  检测字典查询
 *  */
export function getDictionaryWords(data) {//
    return request.get(config.baseApi + "/merchant/dictionarywords/dictionary", data)
}
export function addDictionaryWords(data) {//
    return request.post(config.baseApi + "/merchant/dictionarywords/dictionary", data)
}
export function putDictionaryWords(data) {//
    return request.put(config.baseApi + "/merchant/dictionarywords/dictionary", data)
}
export function deleteDictionaryWords(data) {//
    return request.delete(config.baseApi + "/merchant/dictionarywords/dictionary", data)
}
/**
 * AI标题
 * */
export function getAIReplaceTitleList(data) {//
    return request.get(config.baseApi + "/merchant/ai/replacetitle/pageList", data)
}
export function postAIReplaceTitle(data) {//
    return request.post(config.baseApi + "/merchant/ai/replacetitle/aititle", data)
}
export function getAIReplaceTitleDetail(data) {//
    return request.get(config.baseApi + "/merchant/ai/replacetitle/detail/pageList", data)
}
export function putAIReplaceTitle(id) {//
    return request.put(config.baseApi + `/merchant/ai/replacetitle/aititle/${id}`)
}
export function getFindByProductid(product_id) {//
    return request.get(config.baseApi + `/merchant/ai/replacetitle/detail/${product_id}`)
}
export function putAIReplaceTitleDetail(id, data) {//
    return request.put(config.baseApi + `/merchant/ai/replacetitle/detail/${id}`,data)
}
export function updateAIReplaceBatchTitleDetail(data) {//
    return request.post(config.baseApi + '/merchant/ai/replacetitle/detail/replaceBatch', data)
}

/**
 *  图片生成
 */

export function getAIImgGenerateList(data) {//
    return request.get(config.baseApi + "/merchant/ai/imggenerate/pageList", data)
}
export function postAIImgGenerate(data) {//
    return request.post(config.baseApi + "/merchant/ai/imggenerate/imgs", data)
}
export function getAIImgWhiteImg(data) {//
    return request.get(config.baseApi + "/merchant/ai/imggenerate/detail/getwhiteimg", data)
}
export function putEditImage(data) {//
    return request.put(config.baseApi + `/merchant/ai/imggenerate/detail/editimage/${data.id}`, data)
}
export function getAIImgGenerateTask(data) {//查询 AI 生成任务批次列表
	return request.get(config.baseApi + "/merchant/ai/generate/tasks/pageList", data)
}
export function createAIImgGenerateTask(data) {//创建 AI 生成任务
    return request.post(config.baseApi + `/merchant/ai/generate/tasks/createTask`, data)
}
export function checkAIImgGeneratePower(data) {//校验创建 AI 生成任务所需算力
    return request.post(config.baseApi + `/merchant/ai/generate/tasks/checkPower`, data)
}
export function getAIImgGenerateTaskDetail(data) {//查询 AI 生成任务明细列表
    return request.get(config.baseApi + `/merchant/ai/generate/tasks/detail/pageList`, data)
}
export function pauseAIImgGenerateTask(data) {//暂停 AI 生成任务
    return request.put(config.baseApi + `/merchant/ai/generate/tasks/${data.id}/pause`)
}
export function startAIImgGenerateTask(data) {//启动 AI 生成任务
    return request.put(config.baseApi + `/merchant/ai/generate/tasks/${data.id}/start`)
}
export function cancelAIImgGenerateTask(data) {//取消 AI 生成任务
    return request.put(config.baseApi + `/merchant/ai/generate/tasks/${data.id}/cancel`)
}
export function getAIImgGeneratePowerFees() {//取消 AI 生成任务
    return request.get(config.baseApi + `/merchant/ai/generate/tasks/powerFees`)
}

/**
 * 抖店优化
 * */
export function cleanOffline( data) {//清理下架
	return request.post(config.baseApi + `/merchant/shop/cleanOffline`,data)
}
export function getSeoTrusteeshipStrategy( data) {//查询SEO托管授权状态
	return request.get(config.baseApi + `/merchant/shop/getSeoTrusteeshipStrategy`,data)
}
export function getShopHostingInfo( data) {//查询商家是否已开启AI生图托管
	return request.get(config.baseApi + `/merchant/shop/getShopHostingInfo`,data)
}
export function updateMaterialHostingSwitch( data) {//开启/关闭生图托管状态
	return request.post(config.baseApi + `/merchant/shop/updateMaterialHostingSwitch`,data)
}


/**
 * 报销管理
 * */
export function getUserReimbursement(data) {
	return request.get(config.baseApi + `/merchant/shop/reimbursement/list`,data)
}

export function saveUserReimbursement(data) {
	return request.post(config.baseApi + `/merchant/shop/reimbursement`,data)
}

export function updateUserReimbursement(id, data) {
	return request.put(config.baseApi + `/merchant/shop/reimbursement/${id}`,data)
}

export function deleteUserReimbursement(data) {
	return request.delete(config.baseApi + `/merchant/shop/reimbursement`,data)
}


/**
 * 工单管理
 * */
export function getUserTicket(data) {
	return request.get(config.baseApi + `/merchant/user/ticket/list`,data)
}

export function saveUserTicket(data) {
	return request.post(config.baseApi + `/merchant/user/ticket`,data)
}

export function updateUserTicket(id, data) {
	return request.put(config.baseApi + `/merchant/user/ticket/${id}`,data)
}

export function getTicketInfo(data) {
	return request.get(config.baseApi + `/merchant/user/ticket/${data.ticketId}`,data)
}

export function updateTicketStatus(data) {
	return request.put(config.baseApi + `/merchant/user/ticketstatus/${data.ticketId}`, data)
}

export function saveUserTicketMsg(data) {
	return request.post(config.baseApi + `/merchant/user/ticketmsg`, data)
}
/**
 * 统计分组使用算力和铺货额度情况
 * */
export function getGroupStatisticsList(data) {
	return request.get(config.baseApi + `/merchant/userpower/staisttistics/list`, data)
}
